export class SearchUtil {
  static findMatchingPositions<T>(objectList: T[], searchedValue: any): number[] {
    const matchingPositions: any[] = [];
    for (let i = 0; i < objectList.length; i++) {
      const object = objectList[i];
      for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
          // @ts-ignore
          if (typeof object[key] === 'string' && object[key].includes(searchedValue)) {
            matchingPositions.push(object);
            break;
          } else if (object[key] === searchedValue) {
            matchingPositions.push(object);
            break;
          }
        }
      }
    }

    return matchingPositions;
  }


}
